var cov_72olfek9d = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/TreeSelect/styles/index.ts",
      hash = "c0b9ec2fd9fd952d16cc081d7bf19fbead8d6a86",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/TreeSelect/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 31
        },
        end: {
          line: 5,
          column: 71
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var treeSelectLess = {};
import genaration from '../../utils/classname';
export var treeSelectClass = (cov_72olfek9d.s[0]++, genaration(treeSelectLess, 'treeSelect'));